jQuery(document).ready(function ($) {
    const pick_your_rooms = $('.pick-your-room__rooms');

    pick_your_rooms.each(function () {
        const $gallery = $(this);

        const single_carousel = new Swiper(`#${$gallery.attr('id')}`, {
            loop: false,

            slidesPerView: 1,
            slidesPerGroup: 1,

            longSwipes: false,

            spaceBetween: 16,

            grabCursor: true,

            autoplay: true,
            delay: 8000,

            navigation: {
                prevEl: '.pick-your-room__rooms--prev',
                nextEl: '.pick-your-room__rooms--next'
            },

            breakpoints: {
                768: {
                    slidesPerView: 2,

                    spaceBetween: 32
                }
            }
        });
    });
});